import { AlertDialog } from './../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NotFoundError } from 'src/app/acumatica/acumatica-errors';
import { Customer, CustomerSerivce } from './../../acumatica/EntityServices/Customer.service';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Sound } from 'src/app/services/audio.service';

@Component({
  selector: 'customer-selector',
  templateUrl: './customer-id-selector.component.html',
  styleUrls: ['./customer-id-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CustomerIDSelectorComponent,
      multi: true
    }
  ]
})
export class CustomerIDSelectorComponent {
  private _hasFocus: boolean = false;
  isSearching: boolean = false;

  @Output() onChange = new EventEmitter<Customer | null>();

  @ViewChild('customerIDInput', { static: true }) customerIDInput: any;
  @ViewChild('customerSearchList', { static: true }) customerSearchList!: TemplateRef<any>;
  customerSearchResults: any[] = [];

  private _customerID?: string;
  @Input() get customerID(): string | undefined { return this._customerID; };
  set customerID(value: string | undefined) {
    if (value === undefined) {
      this._customerID = undefined;
      this.customer = null;
      return;
    }

    if (value != this._customerID) {
      this._customerID = value;
      if (!this._hasFocus) {
        // small delay before performing search so other @Inputs() -- expand can be populated
        setTimeout(() => {
          this.performSearch();
        }, 100);
      } else {
        this.customer = null;
      }
    }
  }

  private _expand?: string | string[];
  @Input() get expand(): undefined | string | string[] { return this._expand; }
  set expand(value: undefined | string | string[]) {
    this._expand = value;
  }

  private _customer: Customer | null = null;
  get customer(): Customer | null { return this._customer; };
  set customer(customer: Customer | null) {
    if (this._customer != customer) {
      this._customer = customer;
      if (customer) localStorage.setItem('latest-customer-id', customer!.CustomerID!);
      else localStorage.removeItem('latest-customer-id');
      this.onChange.emit(customer);
      this._changeHandlers.forEach(fn => fn(customer));
    }
  }

  constructor(
    private customers: CustomerSerivce,
    private dialog: MatDialog,
  ) {
    let lastCustomerID = localStorage.getItem('latest-customer-id');
    if (lastCustomerID !== null) {
      let self = this;
      setTimeout(() => { self.customerID = lastCustomerID!; }, 10);
    }
  }

  private _searchingCustomerValue?: string;
  performSearch() {
    if (!this.customerID) {
      if (this.customer) this._customerID = this.customer.CustomerIDName;
      return;
    }

    if (this.customerID === undefined) return;

    // let snackbarRef = this.snackbar.openFromComponent(FeedbackSnackbarComponent, { data: { message: "Searching for Customer..." } });
    this.isSearching = true;
    this._searchingCustomerValue = this.customerID;

    // search for specific customer ID given first
    this.customers.get(this.customerID, { loader: null, expand: this.expand }).subscribe(customer => {
      if (customer) {
        this.isSearching = false;
        this._searchingCustomerValue = undefined;
        this.customer = customer;
        if (!this._hasFocus) this._customerID = customer.CustomerIDName;
      }
    }, err => {
      // try doing Inquiry text search
      this.customers.search(this.customerID!, { loader: null }).subscribe(results => {

        // filter out customers based on status
        results = results.filter(result => (<any>result).CustomerStatus != 'Inactive' && (<any>result).CustomerStatus != 'One-Time');

        this.isSearching = false;
        this._searchingCustomerValue = undefined;
        this.customerSearchResults = results;

        if (results.length == 0) {
          this.dialog.open(AlertDialog, {
            data: {
              message: "Search returned no results",
              icon: 'warning',
              Sound: Sound.GentleBeep,
              buttonText: 'OK'
            }
          }).afterClosed().subscribe(() => { this.selectInputFieldValue() });
        } else {
          this.dialog.open(this.customerSearchList).afterClosed().subscribe(selection => {
            this.customerID = selection.CustomerID;
            this.performSearch();
          });
        }
      },
        err => {
          this.isSearching = false;
          this._searchingCustomerValue = undefined;
          this.customer = null;

          if (!(err instanceof NotFoundError)) {
            throw err;
          }
        });
    });
  }

  doBlur(event: Event) {
    (<HTMLElement>event.target!).blur();
  }

  onFocus(event: Event) {
    this._hasFocus = true;
    this._customerID = this.customer ? this.customer.CustomerID! : (this._searchingCustomerValue || '');
    this.selectInputFieldValue();
  }

  private selectInputFieldValue() {
    let input = (<HTMLInputElement>this.customerIDInput.nativeElement!);
    setTimeout(() => {
      input.focus();
      input.select();
    });
  }

  focus() {
    setTimeout(() => this.selectInputFieldValue(), 100);
  }

  onBlur() {
    this._hasFocus = false;
    if (this._customerID == this.customer?.CustomerID) {
      this._customerID = this.customer!.CustomerIDName;
    } else {
      this.performSearch();
    }
  }

  writeValue(value: Customer | null) {
    this._customer = value;
    this._customerID = value?.CustomerID || '';
  }

  _changeHandlers: any[] = [];
  registerOnChange(fn: any): void { this._changeHandlers.push(fn); }
  registerOnTouched(fn: any): void { }
  setDisabledState?(isDisabled: boolean): void { }
}
